<template>
  <div class="container box" id="container-main">
    <div class="row" id="main-row">
      <div id="vapp">
        <div class="header">
          <h1 class="title">FAQ</h1>
          <div class="buttonsGroup">
            <b-tooltip label="Add a FAQ" position="is-top"
              ><button class="button is-medium is-success" @click="isNewItemActive = true">
                <b-icon icon="plus" size="is-small"></b-icon>
              </button>
            </b-tooltip>
            <b-tooltip label="Edit selected FAQ" position="is-top">
              <button class="button is-medium is-success" @click="EditItem()">
                <b-icon icon="pencil" size="is-small"></b-icon>
              </button>
            </b-tooltip>
            <b-tooltip label="Delete selected FAQ" position="is-top"
              ><button class="button is-medium is-danger" @click="DeleteItem()">
                <b-icon icon="trash" size="is-small"></b-icon>
              </button>
            </b-tooltip>
          </div>
        </div>
        <template>
          <b-table :data="this.faqs" :selected.sync="selected" :loading="this.loading" sticky-header>
            <b-table-column field="title" label="Title" v-slot="props">
              {{ props.row.title }}
            </b-table-column>
          </b-table>
        </template>
        <b-modal :active.sync="isNewItemActive" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog" aria-modal>
          <new-module @submitted="AddFaq" :item="this.formProps"></new-module>
        </b-modal>
        <b-modal :active.sync="isEditItemActive" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog" aria-modal>
          <edit-module @submitted="UpdateFaq" :item="this.editableSelected"></edit-module>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
const EditModule = {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {};
  },
  methods: {},
  template: `
        <form @submit.prevent="">
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Edit FAQ</p>
                </header>
                <section class="modal-card-body">
                <b-field label="Title">
                  <b-input type="text" placeholder="" v-model="item.title"></b-input>
                </b-field>
                <b-field label="Content">
                  <b-input type="textarea" maxlength="6000" placeholder="" v-model="item.content"></b-input>
                </b-field>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" type="button" @click="$parent.close()">Cancel</button>
                    <button class="button is-primary" @click="$emit('submitted')">Update</button>
                </footer>
            </div>
        </form>
        `,
};
const NewModule = {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      data: [],
    };
  },
  methods: {},
  mounted() {},
  template: `
        <form @submit.prevent="">
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Add FAQ</p>
                </header>
                <section class="modal-card-body">
                <b-field label="Title">
                  <b-input type="text" placeholder="" v-model="item.title"></b-input>
                </b-field>
                <b-field label="Content">
                  <b-input type="textarea" maxlength="6000" placeholder="" v-model="item.content"></b-input>
                </b-field>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" type="button" @click="$parent.close()">Cancel</button>
                    <button class="button is-primary" @click="$emit('submitted')">Add</button>
                </footer>
            </div>
        </form>
        `,
};
export default {
  components: {
    NewModule,
    EditModule,
  },
  data: function () {
    return {
      faqs: [],
      selected: {},
      editableSelected: {},
      loading: false,
      isNewItemActive: false,
      isEditItemActive: false,
      formProps: {},
      newApiUrl: "https://api.jeak.co.uk",
    };
  },
  methods: {
    GetItems: async function () {
      axios.get(this.newApiUrl + "/faq").then((response) => {
        this.faqs = response.data;
      });
    },
    DeleteItem: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      if (Object.entries(this.selected).length === 0) {
        this.$buefy.snackbar.open({
          message: "Please select an item to delete first!",
          type: "is-warning",
          position: "is-top",
        });
      } else {
        this.$buefy.dialog.confirm({
          title: "Deleting FAQ",
          message: "Are you sure you want to <b>delete</b> this FAQ? This action cannot be undone.",
          confirmText: "Delete FAQ",
          type: "is-danger",
          hasIcon: true,
          onConfirm: () => {
            axios
              .delete(this.newApiUrl + `/faq/${this.selected.id}`, config)
              .then((response) => {
                if (response.status === 200) {
                  this.$buefy.toast.open("FAQ deleted!");
                  this.GetItems();
                } else {
                  this.$buefy.snackbar.open({
                    message: "An error occurred! If this persists, please contact support",
                    type: "is-danger",
                    position: "is-top",
                  });
                }
              })
              .catch(() => {
                this.$buefy.snackbar.open({
                  message: "An error occurred! If this persists, please contact support",
                  type: "is-danger",
                  position: "is-top",
                });
              });
          },
        });
      }
    },
    AddFaq: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const body = {
        title: this.formProps.title,
        content: this.formProps.content,
      };
      axios.post(this.newApiUrl + `/faq`, body, config);
    },
    UpdateFaq: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      const body = {
        title: this.editableSelected.title,
        content: this.editableSelected.content,
      };
      axios
        .put(this.newApiUrl + `/faq/${this.editableSelected.id}`, body, config)
        .then(() => {
          this.$buefy.toast.open({
            message: "FAQ updated",
            type: "is-success",
          });
          this.GetItems();
          this.selected = "";
          this.isEditItemActive = false;
        })
        .catch((error) => {
          this.$buefy.toast.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
          });
          console.error(error);
        });
    },
    EditItem: async function () {
      if (Object.entries(this.selected).length === 0) {
        this.$buefy.snackbar.open({
          message: "Please select an item to edit first!",
          type: "is-warning",
          position: "is-top",
        });
      } else {
        this.editableSelected = Object.assign({}, this.selected);
        this.isEditItemActive = true;
      }
    },
    HasGroup: function (groups = []) {
      if (!(this.$route && this.$route.params && Array.isArray(this.$route.params.groups))) return false;
      const userGroups = this.$route.params.groups.map((group) => String(group).toLowerCase());
      for (const group of groups) {
        if (userGroups.includes(String(group).toLowerCase())) return true;
      }

      return false;
    },
  },
  mounted() {
    this.GetItems();
  },
};
</script>

<style scoped>
.container {
  margin-top: 20px;
}
#vapp {
  display: grid;
  grid-template-rows: 1fr;
}
.header {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
}
.header h1 {
  grid-column: 1/6;
}
.buttonsGroup {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.b-table {
  height: 100%;
  max-height: 650px;
}
</style>
